const MESSAGES = {
  SETTINGS_SAVED_SUCCESS: "تنظیمات با موفقیت ذخیره شد.",
  ALARMS_SAVED_SUCCESS: "هشدارها با موفقیت ذخیره شد.",

  TELEGRAM_BOT_ACTIVATED: "ربات تلگرام فعال شد.",
  TELEGRAM_BOT_DISABLED: "ربات تلگرام غیرفعال شد.",

  AVATAR_UPLOADED_SUCCESSFULLY: "بارگذاری تصویر با موفقیت انجام شد",
  AVATAR_UPLOAD_FAILED: "بارگذاری تصویر با مشکل مواجه شد",

  SOCKET_CONNECT_FAILED:
    "تلاش برای اتصال به سرور ناموفق بود، لطفا دوباره تلاش کنید .",
  IO_SERVER_DISCONNECT: "ارتباط شما از سمت سرور قطع شد !",
  IO_CLIENT_DISCONNECT: "ارتباط شما با سرور قطع شد !",

  REDIRECT_TO_LOGIN: "هدایت به صفحه ورود اپراتور.",

  CONV_CLOSED: "مکالمه بسته شد.",
  CONV_REJECTED: "مکالمه رد شد.",
  NEW_PRETEXT_ADDED: "پیام با موفقیت اضافه شد.",
  PRETEXT_REMOVED: "پیام با موفقیت حذف شد.",
  PRETEXT_EDITED: "پیام با موفقیت ویرایش شد.",
  USER_INFO_SAVED: "اطلاعات با موفقیت ذخیره شد.",

  CHECK_YOUR_CONNECTION:
    "عدم ارتباط با سرور ! لطفا اتصال خود را به اینترنت بررسی کنید .",

  RECOVERY_EMAIL_SENT:
    "ایمیل بازیابی ارسال شد، لطفا با رمزعبور ارسال شده به ایمیلتان وارد شوید.",
  EMAIL_NOT_FOUND: "کاربری با این ایمیل پیدا نشد!",

  SETTING_UP_APP: "در حال آماده سازی محیط گفتگو ...",
  RECONNECTING: "در حال اتصال ...",
  ALLOW_NOTIFICATION: "برای دریافت پیام ها اعلان های مرورگرتان را فعال کنید.",
  EXPIRE_PACKAGE_ALERT: "اعتبار پکیج شما به پایان رسیده است.",
  ROUTER_FALLBACK_TEXT: "درحال دریافت اطلاعات ...",

  COPIED: "کپی شد",
  COPY_FAILED: "مشکلی رخ داده است! لطفا دوباره تلاش کنید.",

  EMAIL_ID_REQUIRED: "ايميل را وارد نماييد",
  EMAIL_IS_INVALID: "ايميل نامعتبر است",
  PASSWORD_IS_REQUIRED: "رمز عبور را وارد نماييد",

  // handleRequestErrors
  SERVER_ERROR: "خطايی در سرور رخ داده است. لطفا دوباره تلاش كنيد.",
  WRONG_ENTERED_INFO: "اطلاعات وارد شده صحیح نمی باشد!",
  TOO_MANY_REQUEST: "محدودیت تعداد درخواست! لطفا مدتی بعد دوباره تلاش کنید.",

  INVALID_FILE_FORMAT: "فرمت فایل مجاز نمیباشد",
  Image_SIZE_EXCEEDS: "حجم تصویر بیشتر از 500 کیلوبایت است",

  OPERATION_FAILED: "انجام عملیات با خطا روبرو شد",
  BLOCK_ACCEPT_CONV_FOR_EXPIRE_PACKAGE:
    "برای قبول این مکالمه. پکیج خود را تمدید نمایید.",
  BLOCK_ACCEPT_CONV_FOR_NOT_ENOUGH_CHARGE:
    "برای قبول این مکالمه اعتبار خود را شارژ نمایید.",

  BLOCK_START_CONV_FOR_EXPIRE_PACKAGE:
    "برای آغاز این مکالمه پکیج خود را تمدید نمایید",
  BLOCK_START_CONV_FOR_NOT_ENOUGH_CHARGE:
    "برای آغاز مکالمه با کاربر مکالمات خود را شارژ نمایید",

  CHOOSE_RANGE_FOR_BLOCK: "لطفا بازه مورد نظر را انتخاب کنید",

  YOUR_BROWSER_NOT_SUPPORT_NOTIFS: "مرورگر شما از قابلیت اعلان پشتیبانی نمیکند",
  PROBLEM_WHILE_ACTIVATING_NOTIFS:
    "در هنگام فعالسازی اعلانها مشکلی به وجود آمده است.",
  NOTIF_ENABLE_ACCESS_BLOCKED:
    "دسترسی ارسال اعلان ها مسدود شده است، لطفا از طریق مرورگر اعلان هارا فعال کنید ",
  NOTIF_NOT_SUPPORTED: "مرورگر شما از اعلان‌ها پشتیبانی نمیکند",
  NOTIFS_ENABLED: "اعلان ها فعال شدند",
  ERROR_WHILE_ENABLING_NOTIFS:
    "در فرآیند فعالسازی اعلان‌های شما مشکلی به وجود آمده است.",
  NO_ROADMAP_RECORDED: "نقشه سفر این کاربر ثبت نشده است",
  CONVERSATION_EXPIRED:
    "مکالمه ی انتخاب شده منقضی شده است. جهت بازیابی مکالمه با پشتیبانی در ارتباط باشید.",
  FILE_UPLOAD_SERVER_ERROR: "بارگذاری فایل از سمت سرور با مشکل مواجه شده است!",
  FILE_UPLOAD_FAILED: "بارگذاری فایل با خطا مواجه شد! دوباره تلاش کنید.",

  VERIFY_CODE_SUCCESSFULLY_SEND_TO_YOUR_EMAIL:
    "کد تایید با موفقیت به ایمیل شما ارسال شد!",
  VERIFY_CODE_SUCCESSFULLY_SEND_TO_YOUR_PHONE:
    "کد تایید با موفقیت به شماره شما ارسال شد!",

  CONTENT_NOT_FOUND: "محتوايی برای درخواست شما يافت نشد!",
  WRONG_ENTERED_CODE: "کد وارد شده صحیح نیست!",
  WRONG_ENTERED_EMAIL: "ایمیل وارد شده صحیح نمی‌باشد!",
  WRONG_ENTERED_PHONE: "شماره تلفن وارد شده صحیح نمی‌باشد!",
  SENT_REQUEST_NOT_CORRECT: "درخواست ارسال شده صحيح نيست.",

  FILE_SIZE_MORE_THAN_MAX:
    "برای آپلود حجم بیشتر در صورت امکان پکیج خود را ارتقا دهید",

  BLOCK_USER_SUCCESS: "کاربر مورد نظر با موفقیت به لیست سیاه افزوده شد",
  BLOCK_USER_ERROR_DUPLICATE: "این کاربر پیش از این به لیست سیاه اضافه شده است",

  USER_UNBLOCKED_SUCCESS: "کاربر مورد نظر از لیست سیاه خارج شد",
};

export default MESSAGES;
